export class CampaignCardFetchError extends Error {
	readonly status: number;

	constructor(message: string, status: number) {
		super(message);
		this.name = "CampaignCardFetchError";
		this.status = status;
	}
}
